import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EventResource } from 'src/app/interfaces/event-resource';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { EventService } from 'src/app/services/event.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { PushService } from 'src/app/services/push.service';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponentPushMessage implements OnInit {
  /**
   * The current PushMessage
   */
  currentPush: any;
  /**
   * The Form to Edit the Form
   */
  editForm: UntypedFormGroup;
  /**
   * The Options to be slected
   */
  options = [];
  /**
   * Is the Push is in the Past
   */
  isInPast: boolean = false;
  /**
   * 
   */
  typesOfPushMessages = [
    { value: 'NEWS', viewValue: 'Infobeitrag' },
    { value: 'APPOINTMENT', viewValue: 'Veranstaltung' },
    { value: 'EVENTS', viewValue: 'Aktion' }
  ]
  /**
   * constructor
   * init the Forms
   * @param fb 
   * @param route 
   * @param router 
   * @param eventService 
   * @param push 
   * @param overlayService 
   */
  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
    private push: PushService,
    private overlayService: OverlayService) {
    this.route.queryParams.subscribe(params => {
      if (this.router.getCurrentNavigation() != null) {
        this.currentPush = this.router.getCurrentNavigation().extras.state.push;
        console.log(this.currentPush)
      } else {
        this.router.navigate(['caseworker/pushmessages']);
      }
    });

    this.editForm = this.fb.group({
      type: ['NEWS', [Validators.required]],
      eventID: ['', [Validators.required]],
      date: ['', [Validators.required]],
      time: ['', [Validators.required]],
      text: ['', [Validators.required, Validators.maxLength(1024)]],
      send_time: [{ value: '', disabled: true }],
      send_date: [{ value: '', disabled: true }]
    })
  }
/**
 * ngOnInit
 * Patch the Data to the From
 */
  ngOnInit(): void {
    this.editForm.patchValue({
      type: this.currentPush?.type,
      eventID: this.currentPush?.refPublicId,
      date: this.formatDate(this.currentPush?.sendingOn),
      time: this.formatTime(this.currentPush?.sendingOn),
      text: this.currentPush?.message,
      send_time: this.formatTime(this.currentPush?.send),
      send_date: this.formatDate(this.currentPush?.send),
    })
    //Disable Inputs and Btn if the Push is in the Past
    if (new Date() > new Date(this.currentPush.sendingOn) && (this.currentPush.sendingOn != null)) {
      this.editForm.controls.type.disable();
      this.editForm.controls.eventID.disable();
      this.editForm.controls.text.disable();
      this.editForm.controls.date.disable();
      this.editForm.controls.time.disable();
      this.isInPast = true;
    } else {
      this.isInPast = false;
    }
    this.eventService.getEvents(0, 1).subscribe((value: PagedResources<EventResource>) => {
      this.eventService.getEvents(0, value.page.totalElements).subscribe((value: PagedResources<EventResource>) => {
        value.content.forEach(element => {
          this.options.push({ value: element.publicId, viewValue: element.title });
        });
      })
    })
  }
  /***
   * Edit the PushMessage
   */
  editPush() {
    this.editForm.markAllAsTouched();
    if (this.editForm.invalid) {
      return;
    }
    this.currentPush.message = this.editForm.value.text;
    this.currentPush.type = this.editForm.value.type;
    this.currentPush.refPublicId = this.editForm.value.eventID;
    this.currentPush.sendingOn = Number(this.convertToUnix(this.editForm.value.date, this.editForm.value.time));
    this.push.createPushMessage(this.currentPush).subscribe(fromEdit => {
      this.overlayService.openSnackBar("Push Nachricht erfolgreich bearbeitet!");
      this.router.navigate(['../caseworker/pushmessages']);
    })
  }
  /**
   * Convert Date to year-month-day
   * @param date 
   * @returns 
   */
  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    console.log([year, month, day].join('-'))
    return [year, month, day].join('-');
  }
  /**
   * Format the Date to  `${hours}:${minutes}`
   * @param date 
   * @returns 
   */
  private formatTime(date) {
    const d = new Date(date);
    let minutes = d.getMinutes().toString();
    let hours = d.getHours().toString();
    if (hours.length < 2) hours = '0' + hours;
    if (minutes.length < 2) minutes = '0' + minutes;
    return `${hours}:${minutes}`
  }
  /**
   * Convert Date to UNIX TimeFormat
   * @param date 
   * @param time 
   * @returns 
   */
  private convertToUnix(date, time) {
    let t = new Date(date)
    const chars = time.split(':')
    t.setHours(chars[0])
    t.setMinutes(chars[1])
    let unix = (Math.floor(t.getTime() / 1000) + '000');
    return unix;
  }
}
